import CollapsedAltQuoteOffers from "./CollapsedAltQuoteOffers";

export default CollapsedAltQuoteOffers;
